export default __webpack_public_path__ + "static/media/AttachmentsIcon.1005ddb1.svg";